import { fetcherWithToken } from '@/shared/api/fetcher';
import useSWRMutation from 'swr/mutation';

export const useConfirmApi = () => {
  const { trigger: confirmTriggerEmail } = useSWRMutation(
    '/confirm/email',
    fetcherWithToken
  );

  const { trigger: confirmTriggerPhone } = useSWRMutation(
    '/confirm/phone',
    fetcherWithToken
  );
  return { confirmTriggerEmail, confirmTriggerPhone };
};
